import * as z from "zod/v4";

export const getOptimizedBatchFulfillmentGroupIds = {
  name: "getOptimizedBatchFulfillmentGroupIds" as const,
  input: z.object({ limit: z.number().int().positive() }),
  output: z.object({
    groups: z.array(
      z.object({ id: z.string(), filterName: z.string().nullable() }),
    ),
    totalCount: z.number(),
  }),
};
